// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_livro {
  height: 100%;
  margin: 1.9em;
}

.caixa_livro {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.caixa_livro button {
  width: 15%;
  height: 2.4em;
  font-size: 1.2em;
  border: none;
  border-radius: 0.5em;
  color: var(--cor-branco);
  background-color: var(--cor-roxoEscuro);
  cursor: pointer;
}

.caixa_livro h1 {
  font-family: "Roboto";
  font-weight: normal;
}

.caixa_filtros {
  width: 100%;
  height: 3em;
  margin-top: 1.5em;
  display: flex;
  justify-content: space-between;
}

.input_buscar {
  width: 77%;
  border-radius: 0.5em;
  display: flex;
  justify-content: space-between;
  background-color: var(--cor-roxoInput);
}

.input_buscar input {
  width: 90%;
  margin-left: 1.5em;
  font-size: 1em;
  border: none;
  background-color: transparent;
}

.input_buscar:hover {
  background-color: var(--cor-roxoClaro);
}

.input_buscar input:focus {
  outline: none;
}

.input_buscar button {
  width: 10%;
  border: none;
  cursor: pointer;
  background-color: transparent;
}

.caixa_tabela {
  height: 72%;
  margin-top: 1.5em;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.caixa_tabela span {
  font-family: "Roboto";
  margin-top: 5% ;
  font-size: large;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/paginas/funcionario/Livros.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;EACxB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".container_livro {\n  height: 100%;\n  margin: 1.9em;\n}\n\n.caixa_livro {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n\n.caixa_livro button {\n  width: 15%;\n  height: 2.4em;\n  font-size: 1.2em;\n  border: none;\n  border-radius: 0.5em;\n  color: var(--cor-branco);\n  background-color: var(--cor-roxoEscuro);\n  cursor: pointer;\n}\n\n.caixa_livro h1 {\n  font-family: \"Roboto\";\n  font-weight: normal;\n}\n\n.caixa_filtros {\n  width: 100%;\n  height: 3em;\n  margin-top: 1.5em;\n  display: flex;\n  justify-content: space-between;\n}\n\n.input_buscar {\n  width: 77%;\n  border-radius: 0.5em;\n  display: flex;\n  justify-content: space-between;\n  background-color: var(--cor-roxoInput);\n}\n\n.input_buscar input {\n  width: 90%;\n  margin-left: 1.5em;\n  font-size: 1em;\n  border: none;\n  background-color: transparent;\n}\n\n.input_buscar:hover {\n  background-color: var(--cor-roxoClaro);\n}\n\n.input_buscar input:focus {\n  outline: none;\n}\n\n.input_buscar button {\n  width: 10%;\n  border: none;\n  cursor: pointer;\n  background-color: transparent;\n}\n\n.caixa_tabela {\n  height: 72%;\n  margin-top: 1.5em;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.caixa_tabela span {\n  font-family: \"Roboto\";\n  margin-top: 5% ;\n  font-size: large;\n  font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
